import React from 'react';

const FramerMotionIcon = () => {
  return (
    <svg xmlns="http:www.w3.org/2000/svg" viewBox="0 0 14 21">
      <path d="M0 0h14v7H7zm0 7h7l7 7H7v7l-7-7z" fill="currentColor"></path>
    </svg>
  );
};

export default FramerMotionIcon;
